import { createStore } from 'vuex'

import { alert } from './alert.module'
import { auth } from './auth.module'
import { usersSubmission } from './user.module'
import { projectSubmission } from './projects.module'
import { labelledImagesSubmission } from './labels.module'
import { license } from './license.module'
import { staffReport } from './staff.report.module'
import { staffSubmission } from './staff.submission.module'
import { pmsMetrics } from './pms-metrics.module'
import { uploader } from './uploader.module'
import { zipUploader } from './zipUploader.module'
import { labelerAnnotation } from './labeler.annotation.module'
import { labelerImageQueue } from './labeler.imageQueue.module'
import { workspacePanel } from './workspace.panel.module'
import { workspaceTheme } from './workspace.theme.module'

export const store = createStore({
  modules: {
    alert,
    auth,
    staffReport,
    staffSubmission,
    pmsMetrics,
    projectSubmission,
    usersSubmission,
    labelledImagesSubmission,
    license,
    uploader,
    zipUploader,
    labelerAnnotation,
    labelerImageQueue,
    workspacePanel,
    workspaceTheme
  }
})
